<template>
 <div>
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="searchBox inpBox">
            <div class="item">
               <!-- <el-form-item label="货物来源:" prop="productSource">
                <el-select  v-model="searchFrom.productSource"  placeholder="请选择">
                  <el-option v-for="val in hwly" :label="val.name" :value="val.val" :key="val.val"></el-option>
                </el-select>
              </el-form-item> -->
            <el-form-item label="所在仓库:" prop="organizationId">
                <el-select  v-model="searchFrom.organizationId"  placeholder="">
                  <el-option v-for="val in warehouseList" :label="val.tenantName" :value="val.tenantCode" :key="val.tenantCode"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="收货单位:" prop="receivingCompany">
                <el-input  placeholder="" v-model="searchFrom.receivingCompany"></el-input>
              </el-form-item>
              <el-form-item label="收货人:" prop="receivingPerson">
                <el-input  placeholder="" v-model="searchFrom.receivingPerson"></el-input>
              </el-form-item>
              <el-form-item label="收货人电话:" prop="receivingPhone">
              <el-input  placeholder="" v-model="searchFrom.receivingPhone"></el-input>
              </el-form-item>
              <el-form-item label="计价方式 :" prop="pricingMethod" >
              <el-select  v-model="searchFrom.pricingMethod"  placeholder="请选择" >
                <el-option v-for="val in jjfangshi" :label="val.name" :value="val.val" :key="val.val"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付方式 :" prop="paymentType">
              <el-select  v-model="searchFrom.paymentType"  placeholder="请选择">
                <el-option v-for="val in jsfangshi" :label="val.name" :value="val.val" :key="val.val"></el-option>
              </el-select>
            </el-form-item>
             <el-form-item label="提单状态 :" prop="status">
              <el-select  v-model="searchFrom.status"  placeholder="请选择" >
                <el-option v-for="val in tdzt" :label="val.name" :value="val.val" :key="val.val"  v-if="(searchFrom.productSource==2&&val.type==1)||(searchFrom.productSource==1&&val.type==2)?false:true"></el-option>
              </el-select>
            </el-form-item>
               <el-form-item label="创建时间:" prop="createTime">
                    <el-date-picker
                      v-model="searchFrom.createTime"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="期望发货时间:" prop="hopeDeliverDate">
                    <el-date-picker
                      v-model="searchFrom.hopeDeliverDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                   <el-form-item label="期望到货时间:" prop="hopeReceivingDate">
                    <el-date-picker
                      v-model="searchFrom.hopeReceivingDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
            </div>
        </div>

       <div class="searchBtnBox">
         <el-form-item btnCode="004P004B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" btnCode="004P004B001"  v-if="btnFlg[1]" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="submitFn">提交</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
        <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick" class="table" height="100%" style="width: 100%" center :row-key="getRowKeys" >
        <!-- <el-table-column type="selection" width="30" :reserve-selection="true"></el-table-column> -->
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="154">
            <template slot-scope="scope">
              <div>
              <el-button type="text" size="mini" btnCode="004P004B002"  v-if="btnFlg[2]" v-show="scope.row.status==3&&scope.row.productSource==1?true:false"  @click="modifyFn(scope.row)">修改</el-button>
              <el-button type="text" size="mini" btnCode="004P004B003"  v-if="btnFlg[3]" v-show="scope.row.productSource==2?false:true"  @click="detailsFn(scope.row)">详情</el-button>
              <el-button type="text" size="mini" btnCode="004P004B004"  v-if="btnFlg[4]" v-show="scope.row.status==3?true:false" @click="submitFn(scope.row)">提交</el-button>
              <el-button type="text" size="mini" btnCode="004P004B005"  v-if="btnFlg[5]" v-show="scope.row.status==3?true:false" @click="recallFn(scope.row)">撤回</el-button>
              <el-button type="text" size="mini" btnCode="004P002B006"  v-if="btnFlg[6]" v-show="scope.row.auditStatus!=0"    @click="lookSH(scope.row.id)">审核进度</el-button>
              <!-- <el-button type="text" size="mini"  @click="lookSH(scope.row.id)">审核进度</el-button> -->
              <el-button type="text" size="mini" btnCode="004P002B007"  v-if="btnFlg[7]" v-show="(scope.row.auditStatus==0||scope.row.auditStatus==2)&&scope.row.status>=4"   @click="lookPZ(scope.row.id)">查看凭证</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column property="billNo" width="200" label="提货单号"></el-table-column>
        <el-table-column property="status" label="提单状态" >
          <template scope="scope">
            {{[ "审核中", "未通过", "待提交", "已提交", "配货中", "配货完成", "出库中", "出库完成" , "收货中","已收货"][scope.row.status-1]}}
          </template>
        </el-table-column>
         <el-table-column property="auditStatus" label="审核状态" >
          <template scope="scope">
            {{[ "不审核", "审核中" ,"审核通过" ,"审核未通过"][scope.row.auditStatus]}}
          </template>
        </el-table-column>
        <el-table-column property="receivingCompany" width="150"  label="收货单位"></el-table-column>
        <el-table-column property="productNum" label="委托件数"></el-table-column>
        <el-table-column property="allWeight"  width="120"  label="重量(吨)"></el-table-column>
        <el-table-column property="organizationName" width="150"  label="所在仓库"></el-table-column>
        <el-table-column property="receivingPerson" width="150"  label="收货人"></el-table-column>
        <el-table-column property="receivingPhone" width="150" label="收货人电话"></el-table-column>
        <el-table-column property="receivingAddress" width="250"  label="收货地址"></el-table-column>
          <el-table-column  width="160" property="hopeDeliverDate" :formatter="dateFormat" label="期望发货时间"></el-table-column>
          <el-table-column width="160" property="hopeReceivingDate" :formatter="dateFormat" label="期望到货时间"></el-table-column>
           <el-table-column property="checkReason" width="160" label="退回原因"></el-table-column>
          <el-table-column property="carrierTenantName" width="250"  label="配货单位"></el-table-column>
          <el-table-column prop="createTime" width="160" :formatter="dateFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 修改 -->
    <el-dialog  title="修改"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogVisible" width="900px" center>
         <el-form :inline="true" :rules="rules" :model="HTfrom" ref="HTfrom" class="demo-form-inline inpBox" label-width="120px" size="mini">
            <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
        </h4>
        <div>
            <el-form-item  class="is-required" label="发货单位:" prop="deliverCompany">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="20" :readonly="true"  v-model="HTfrom.deliverCompany"></el-input>
          </el-form-item>
          <el-form-item    class="is-required" label="发货人:" prop="deliverPerson">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="10" :readonly="true"  v-model="HTfrom.deliverPerson"></el-input>
          </el-form-item>
          <el-form-item label="发货人电话:" class="is-required" prop="deliverPhone">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="HTfrom.deliverPhone"></el-input>
          </el-form-item>
          <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1">
            <el-input  placeholder="请选择发货地址" class="disabled" maxlength="11" :readonly="true"  v-model="HTfrom.deliverAddress"></el-input>
          </el-form-item>
           <el-form-item >
              <el-button type="text"  @click="addxzdzFn(2)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>使用发货地址簿</el-button>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="收货单位:" prop="receivingCompany">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="20" :readonly="true"  v-model="HTfrom.receivingCompany"></el-input>
        </el-form-item>
        <el-form-item  label="收货人:" prop="receivingPerson">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="10" :readonly="true"  v-model="HTfrom.receivingPerson"></el-input>
        </el-form-item>
        <el-form-item label="收货人电话:" prop="receivingPhone">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="HTfrom.receivingPhone"></el-input>
        </el-form-item>
          <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1">
          <el-input  placeholder="请选择收货地址" class="disabled" maxlength="11" :readonly="true"  v-model="HTfrom.receivingAddress"></el-input>
        </el-form-item>
        <el-form-item >
              <el-button type="text"  @click="addxzdzFn(1)"><i class="fa fa-address-book-o iconFont" aria-hidden="true"></i>使用收货地址簿</el-button>
          </el-form-item>
        </div>
      </div>
      <hr>
      <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>承运车队</span>
            </h4>
            </div>
          <el-form-item label="自家承运:" prop="isSelfCarrief" class="ziti"  v-if="isFleet">
            <template >
              <el-radio-group v-model="HTfrom.isSelfCarrief" @change="changeRadeoHandler(HTfrom.isSelfCarrief)">
                <el-radio :label="1" >是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>

          <el-form-item label="选择车队:" prop="carrierTenantId" class="chedui">
            <template style="width: 500px">
              <el-select v-model="HTfrom.carrierTenantId" :disabled="radiodisabled" :placeholder="radioFleet" >
                <el-option
                  v-for="item in optionsfleet"
                  :key="item.tenantCode"
                  :label="item.tenantName"
                  :value="item.tenantCode">
                </el-option>
              </el-select>
            </template>
          </el-form-item>

      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>其他信息</span>
        </h4>
        <div>

      <el-form-item label="期望发货时间:" prop="hopeDeliverDate">
            <el-date-picker
              v-model="HTfrom.hopeDeliverDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
      </el-form-item>
      <el-form-item label="期望到货时间:" prop="hopeReceivingDate">
            <el-date-picker
              v-model="HTfrom.hopeReceivingDate"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
      </el-form-item>
      <div>
          <el-form-item label="备注:" class="remark" prop="remark" >
            <el-input  placeholder=""  maxlength="500" v-model="HTfrom.remark"></el-input>
          </el-form-item>
      </div>
      </div>
      </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('HTfrom')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog  title="确认密码" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog"   :visible.sync="dialogPaw" width="500px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="pwdFrom" ref="pwdFrom" class="demo-form-inline" label-width="100px" size="mini">
            <el-form-item label="密码:" prop="password">
                  <el-input  placeholder=""  type="password" v-model="pwdFrom.password"></el-input>
                </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPaw = false">取 消</el-button>
        <el-button type="primary" @click="pwaSaveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 审核进度 -->
    <el-dialog  title="审核进度" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog" width="900px"   :visible.sync="dialogSH" center>
      <el-steps  align-center :active="spjd.length" finish-status="success">
        <el-step v-for="item in spjd" :key="item.id" :status="item.status==1?'success':item.status==0?'process':'error'">
          <template slot='description'>
            <div>{{item.checkUserName}}</div>
            <div>{{item.checkTime|dateFormat}}</div>
            <div>{{item.checkReason}}</div>
          </template>
        </el-step>
      </el-steps>
    </el-dialog>
     <!-- 选择地址 -->
  <selectAddress :type= "addressType"  v-if="dialogXzdz"  @handleCurrentChange="handleCurrentChange1" @destroy="destroy"></selectAddress>

</div>
</template>

<script>
// import axios from 'axios'
import { getBtn } from '@/utils/getButton'
import { sBillList, getConsignorInfo, getRelationCustomerFleet, sBillUpdate, sBillDelete, submitSBill, warehouseList, checkPwd, getSBillFileUrl, getAuditCFlow } from '@/api/soc-stock'
import selectAddress from '@/components/networkFreight/selectAddress.vue'
import { encryption } from '@/utils/util'
export default {
  components: {
    selectAddress
  },
  data () {
    return {
      dialogPaw: false,
      getRowKeys (row) {
        return row.id
      },
      dialogVisible: false,
      loading: false,
      dialogSH: false,
      spjd: [],
      h: '500px',
      weight: '0.00',
      takegoodsDialog: false,
      entrustDialog: false,
      tableList: [],
      warehouseList: [],
      total: 0,
      jjfangshi: [
        { val: '', name: '请选择' },
        { val: 1, name: '按吨' },
        { val: 2, name: '包干' }
      ],
      jsfangshi: [
        { val: '', name: '请选择' },
        { val: 1, name: '电汇' },
        { val: 2, name: '现金' },
        { val: 3, name: '其他' }
      ],
      hwly: [
        { val: '', name: '请选择' },
        { val: 1, name: '系统货物' },
        { val: 2, name: '非系统货物' }
      ],
      tdzt: [
        { val: '', name: '请选择', type: 0 },
        // { val: 1, name: '审核中', type: 2 },
        // { val: 2, name: '未通过', type: 2 },
        { val: 3, name: '待提交', type: 0 },
        { val: 4, name: '已提交', type: 1 },
        { val: 5, name: '配货中', type: 0 },
        { val: 6, name: '配货完成', type: 0 },
        { val: 7, name: '出库中', type: 1 },
        { val: 8, name: '出库完成', type: 1 },
        { val: 9, name: '收货中', type: 0 },
        { val: 10, name: '已收货', type: 0 }

      ],
      szck: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        productSource: 1,
        productType: ''
      },
      HTfrom: {
        allPrice: 0,
        storagePrice: '',
        allWeight: '',
        price: '',
        pricingMethod: ''
      },
      pwdFrom: {},
      dialogAddress: false,
      types: [
        { name: '收货地址', id: 1 },
        { name: '发货地址', id: 2 }
      ],
      addFrom: {},
      dialogXzdz: false,
      addressType: 1,
      currentRow: {},
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      radiodisabled: '',
      radioFleet: '',
      optionsfleet: [
        {
          tenantCode: '',
          tenantName: ''
        }
      ],
      isFleet: true,
      rules: {
        type: [
          { required: true, message: '请选择地址类型', trigger: 'blur' }
        ],
        areaCode: [
          { required: true, message: '请选择省市县', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        receivingCompany: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        receivingPerson: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        receivingPhone: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        deliverAddress: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        receivingAddress: [
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        price: [
          this.rule.price
        ],
        deliverCompany: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        deliverPerson: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ],
        deliverPhone: [
          { required: true, message: '请选择发货地址', trigger: 'blur' }
        ]

      },
      btnFlg: [],
      btnIdArr: ['004P004B000', '004P004B001', '004P004B002',
        '004P004B003', '004P004B004', '004P004B005',
        '004P004B006', '004P004B007']

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/takeGoods/sysTake')
    this.getList(this.searchFrom)
    warehouseList().then(res => {
      this.warehouseList = res
      this.warehouseList.unshift({ tenantName: '请选择', tenantCode: '' })
    })
    this.getConsignorInfo()
    // this.getAddress()
  },
  watch: {
    HTfrom: {
      handler (newName, oldName) {
        var allPrice = this.HTfrom.allWeight * this.HTfrom.price
        if (!Number.isNaN(allPrice)) {
          if (allPrice == 0) {
            if (this.HTfrom.storagePrice == '' || this.HTfrom.storagePrice == 0) {
              this.$set(this.HTfrom, 'allPrice', 0)
            } else {
              this.$set(this.HTfrom, 'allPrice', this.HTfrom.storagePrice)
            }
          } else {
            var yunfei = 0
            if (this.HTfrom.pricingMethod == 1) {
              let weight = this.HTfrom.allWeight
              let price = this.HTfrom.price
              yunfei = this.$math.format(this.$math.multiply(this.$math.bignumber(weight), this.$math.bignumber(price)))
            } else if (this.HTfrom.pricingMethod == 2) {
              yunfei = this.HTfrom.price
            }
            if (this.HTfrom.storagePrice == '' || this.HTfrom.storagePrice == 0) {
              this.$set(this.HTfrom, 'allPrice', fomatFloat(yunfei, 2))
            } else {
              let n = this.$math.format(this.$math.add(this.$math.bignumber(yunfei), this.$math.bignumber(this.HTfrom.storagePrice)))
              this.$set(this.HTfrom, 'allPrice', fomatFloat(n, 2))
            }
          }
        }

        function fomatFloat (num, n) {
          var f = parseFloat(num)
          if (isNaN(f)) {
            return false
          }
          f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n) // n 幂
          var s = f.toString()
          var rs = s.indexOf('.')
          // 判定如果是整数，增加小数点再补0
          if (rs < 0) {
            rs = s.length
            s += '.'
          }
          while (s.length <= rs + n) {
            s += '0'
          }
          return s
        }
      },
      deep: true
      // immediate: true
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {

    // 审核进度
    lookSH (id) {
      this.dialogSH = true
      let formData = new FormData()
      formData.append('id', id)
      formData.append('formType', 1)
      getAuditCFlow(formData).then(res => {
        this.spjd = res
      })
    },
    // 查看凭证
    lookPZ (id) {
      let formData = new FormData()
      formData.append('id', id)
      getSBillFileUrl(formData).then(res => {
        this.$router.push({
          name: 'Pdf',
          query: { path: res }
        })
      })
    },
    // 提交
    submitFn (row) {
      this.dialogPaw = true
      this.id = row.id
    },
    pwaSaveFn () {
      let data = encryption({
        data: this.pwdFrom,
        key: this.global.key,
        param: ['password']
      })
      this.$refs.pwdFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          checkPwd(data).then(res => {
            submitSBill({ id: this.id }).then(res => {
              loading.close()
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.dialogPaw = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          // eslint-disable-next-line handle-callback-err
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '验证密码失败',
              type: 'error',
              duration: 0,
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 修改
    modifyFn (row) {
      this.HTfrom = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
      this.changeRadeoHandler(this.HTfrom.isSelfCarrief)
    },
    getConsignorInfo () {
      getConsignorInfo().then(res => {
        if (res == false) {
          this.isFleet = false
        }
        if (res == true) {
          this.isFleet = true
        }
      })
    },
    changeRadeoHandler (value) {
      if (value == '2') { // 否
        this.radioFleet = '请选择车队'
        this.radiodisabled = false
        this.optionsfleet = []
        getRelationCustomerFleet().then(res => {
          var huowei = { tenantCode: this.HTfrom.organizationId, tenantName: this.HTfrom.organizationName }
          this.optionsfleet = JSON.parse(res)
          this.optionsfleet.unshift(huowei)
          this.HTfrom.carrierTenantId = this.optionsfleet[0].tenantCode
        })
      } else if (value == '1') { // 是
        this.HTfrom.carrierTenantId = ''
        this.radioFleet = '自家车队'
        this.radiodisabled = true
      }
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          sBillUpdate(this.HTfrom).then(res => {
            loading.close()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.dialogVisible = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 撤回
    recallFn (row) {
      this.$confirm('是否执行撤回操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sBillDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '撤回成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 详情
    detailsFn (row) {
      if (row.productSource == 2) {
        if (row.status == 5 || row.status == 6 || row.status == 7 || row.status == 8) {
          this.$router.push({ name: 'takeDetails', query: { id: row.id, weight: row.allWeight } })
        } else {
          this.$router.push({ name: 'goodsDetails', query: { id: row.id } })
        }
      } else {
        this.$router.push({ name: 'takeDetails', query: { id: row.id, weight: row.allWeight } })
      }
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    destroy () {
      this.dialogXzdz = false
    },
    // 选择地址
    addxzdzFn (n) {
      this.addressType = n
      this.dialogXzdz = true
    },
    handleCurrentChange1 (val) {
      this.currentRow = val
      this.dialogXzdz = false
      if (this.addressType == 1) {
        this.$set(this.HTfrom, 'receivingCompany', this.currentRow.company)
        this.$set(this.HTfrom, 'receivingPerson', this.currentRow.person)
        this.$set(this.HTfrom, 'receivingPhone', this.currentRow.phone)
        this.$set(this.HTfrom, 'receivingAddress', this.currentRow.name)
        this.HTfrom.provinceCode = this.currentRow.provinceCode
        this.HTfrom.cityCode = this.currentRow.cityCode
        this.HTfrom.areaCode = this.currentRow.areaCode
        this.HTfrom.provinceName = this.currentRow.provinceName
        this.HTfrom.cityName = this.currentRow.cityName
        this.HTfrom.areaName = this.currentRow.areaName
      } else {
        this.$set(this.HTfrom, 'deliverCompany', this.currentRow.company)
        this.$set(this.HTfrom, 'deliverPerson', this.currentRow.person)
        this.$set(this.HTfrom, 'deliverPhone', this.currentRow.phone)
        this.$set(this.HTfrom, 'deliverAddress', this.currentRow.name)
      }
      this.$refs.HTfrom.clearValidate()
    },

    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取货物列表
    getList (searchFrom) {
      sBillList(searchFrom).then(res => {
        console.log(res)
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    closeDialog () {
      if (this.$refs.HQform !== undefined) {
        this.$refs.HQform.resetFields()
      }
      if (this.$refs.THform !== undefined) {
        this.$refs.THform.resetFields()
      }
      if (this.$refs.HTfrom !== undefined) {
        this.$refs.HTfrom.resetFields()
      }
      this.pwdFrom = {}
      this.$refs.table.clearSelection()
    },
    // 重置
    resetForm (formName) {
    // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        productSource: 1,
        hopeDeliverDate: null,
        hopeReceivingDate: null,
        createTime: null
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      var str = ''
      if (cellValue == null) {
        str = ''
      } else {
        str = t.getFullYear() + '-' + month + '-' + date + ' ' + hour + ':' + minutes + ':' + seconds
      }
      return str
    // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }

  }
}
</script>

<style scoped lang='less'>
.searchBox{
  display: flex;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.gjhBox{
      flex-shrink: 0;
}
.gjhBox /deep/.el-textarea__inner{
  width:150px;
}

/deep/.el-input.is-disabled .el-input__inner{
    border: none;
    background-color: #dcedff;
    color: #606266;
}
.dialogtnBox{
  display: flex;
  justify-content: space-between;
  /deep/.el-form-item--mini.el-form-item{
        margin-bottom: 15px!important;
  }

}

</style>
